import { Badge, Button } from 'react-bootstrap';
import { useState } from 'react';
import { WithTooltip } from '../WithTooltip/WithTooltip';
import 'unicharadata/trial/unicharadata-load';

export type IExtendedKeyboard = IExtendedKeyboardRow[];
type IExtendedKeyboardRow = ('shift' | null | [string, string])[];

const ExtendedKeyboardComponent = ({ keyboard = [], onClick }: { keyboard: IExtendedKeyboard; onClick: (character: string) => any }) => {
  const uni = (window as any).unicharadata;

  const [shift, setShift] = useState(0);

  if (!keyboard || !keyboard.length) return null;

  return (
    <>
      {keyboard.map((row, i, arr) => (
        <div
          style={{ display: 'grid', gridTemplateColumns: `repeat(${row.length}, 1fr)`, gap: '0.25rem' }}
          key={i.toString()}
          className={i == arr.length - 1 ? '' : 'mb-1'}
        >
          {row.map((character, ii) => {
            return (
              <WithTooltip
                text={`[${character?.[shift]}] ${uni.lookupname(character?.[shift])}`}
                hide={!character || !Array.isArray(character)}
                big={false}
                placement={'bottom'}
                key={ii.toString()}
              >
                <Button
                  as={Badge}
                  key={ii.toString()}
                  style={{ pointerEvents: !!character ? null : 'none' }}
                  onClick={() => {
                    if (character == 'shift') {
                      setShift((current) => +!current);
                      return;
                    }
                    onClick(character[shift]);
                  }}
                  variant={(() => {
                    if (!character) return 'dark';
                    if (character == 'shift' && shift) return 'primary';
                    if (character == 'shift' && !shift) return 'secondary';
                    return 'light';
                  })()}
                >
                  <span>
                    {(() => {
                      if (!character) return <>&nbsp;</>;
                      if (character == 'shift') return <>&#x21e7;</>;
                      return character[shift];
                    })()}
                  </span>
                </Button>
              </WithTooltip>
            );
          })}
        </div>
      ))}
    </>
  );
};

export { ExtendedKeyboardComponent as ExtendedKeyboard };
